/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import moment from 'moment';
import { Avatar, Checkbox, Chip, Stack, Typography } from '@mui/material';
import LoopIcon from '@mui/icons-material/Loop';
import {
  REGISTER_TOGGLE_ROBOT_SELECT,
  REPEAT_OPTION_MONTHLY,
  REPEAT_OPTION_WEEKLY,
  REPEAT_OPTION_YEARLY,
} from '../../common/consts';
import { getFile } from '../../api/bot';

const ScheduleItem = ({ data, onChangeCheck, checkedData, bManagerMode }) => {
  const { execTime, repeatValue, group, title, bot } = data;

  const executeTime = moment(new Date(execTime)).format('HH:mm');
  const { type, value } = repeatValue;
  const cycleType = () => {
    switch (type) {
      case REPEAT_OPTION_WEEKLY:
        return '매주';
      case REPEAT_OPTION_MONTHLY:
        return '매월';
      case REPEAT_OPTION_YEARLY:
        return '매년';
      default:
        return '한번';
    }
  };
  const { date, day, month, times } = value;
  const cycleDetail = () => {
    if (type === REPEAT_OPTION_YEARLY && month && date) {
      return `${month + 1}월 ${date}일`;
    }
    if (type === REPEAT_OPTION_MONTHLY && date) {
      return `${date}일`;
    }
    if (type === 'weekly' && day) {
      const days = day.reduce((acc, cur) => {
        const dayLabel = moment().day(cur).format('ddd');
        return `${acc} ${dayLabel}`;
      }, '');
      return days;
    }
    return '';
  };

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Checkbox
        checked={!!(data._id in checkedData)}
        disabled={
          bManagerMode ? group.type !== REGISTER_TOGGLE_ROBOT_SELECT : false
        }
        value={JSON.stringify(data)}
        onChange={onChangeCheck}
        color="secondary"
      />
      {bot && (
        <Avatar
          variant="square"
          src={getFile({ icon: bot })}
          alt={title}
          size="small"
        />
      )}
      <Typography sx={{ width: '100%' }}>{title}</Typography>
      <Stack alignItems="center">
        <Chip
          className={`badge-${type}`}
          sx={{ fontSize: '8px', '&>span': { p: 0 }, height: '18px', px: 1 }}
          label={cycleType()}
        />
        <Typography sx={{ fontSize: '10px' }}>{cycleDetail()}</Typography>
      </Stack>
      <Typography color="secondary.dark" fontWeight="bold">
        {executeTime}
      </Typography>
      <Stack direction="row">
        <LoopIcon size="small" />
        <Typography>{times || 1}</Typography>
      </Stack>
    </Stack>
  );
};

export default ScheduleItem;
